import React from 'react';
import PropTypes from 'prop-types';
import {SidebarContainer} from '../';
import FieldList from './field-list';
import FieldPicker from './field-picker';
import FieldSetup from './field-setup';
import {SidebarLeft} from '../ui';
import {Container} from '../ui';
import { Modal } from 'react-bootstrap';

class FormBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      next_field_prototype : null,
      selected : -1,
      tmp_field : null,
    }
    this.handleFieldSelect = this.handleFieldSelect.bind(this);
    this.handleClearPrototype = this.handleClearPrototype.bind(this);
    this.setSelectedField = this.setSelectedField.bind(this);
  }
  handleFieldChange(field) {
    this.setState({tmp_field : field, dirty: true});
  }
  handleFieldSelect(fieldPrototype) {
    this.setState({ next_field_prototype : fieldPrototype });
  }
  handleClearPrototype() {
    this.setState({ next_field_prototype : null });
  }
  setSelectedField(id) {
    if(this.state.dirty) {
      return this.setState({confirm_field_change: true, next_id: id})
    }
    this.setState({selected : id, tmp_field : this.props.fields.find(({_id}) => (_id == id))});
  }
  render() {
    return <div title="Client Builder">
      <div className="row">
        <div className="col-xs-12 col-md-2">
          <div className="widget">
            <div className="widget-header clearfix">
              <h4 className="title pull-left mt-xs"><i className="fa fa-plus"></i> New Field</h4>
            </div>
            <div className="widget-content">
              <FieldPicker onSelect={this.handleFieldSelect.bind(this)} />
            </div>
          </div>
          <hr />
          {this.state.selected != -1 ? (<div className="animated fadeInRight widget">
            <div className="widget-header clearfix">
              <h4 className="title pull-left mt-lg"><i className="fa fa-cog"></i> {this.state.tmp_field.label} Settings</h4>
            </div>
            <div className="widget-content">
              <div className="row">
                  <div className="col-xs-12">
                    <FieldSetup
                      type={this.props.type}
                      field={this.state.tmp_field}
                      onChange={this.handleFieldChange.bind(this)}
                    />
                  </div>
                  <div className="col-xs-6 mb-sm">
                    <div onClick={e => {
                      this.props.onDeleteField(this.state.tmp_field);
                      this.setSelectedField(-1);
                    }} className="btn btn-block btn-danger"><i className="fa fa-trash"></i> Delete</div>
                  </div>
                  <div className="col-xs-6 mb-sm">
                    <div onClick={e => this.setSelectedField(-1)} className="btn btn-block btn-default">Close</div>
                  </div>
                  <div className="col-xs-12 mb-sm">
                    <div onClick={e =>{
                      this.props.onUpdateField(this.state.tmp_field);
                      this.setSelectedField(-1);
                    }} className="btn btn-block btn-success">Save </div>
                  </div>
              </div>
            </div>
          </div>) : ''}
        </div>
        <div className="col-xs-12 col-md-10">
          {this.props.fields.length <= 0 ? (
            <div className="panel panel-info">
              <div className="panel-heading">
                <h3 className="panel-title">Welcome!</h3>
              </div>
              <div className="panel-body">
                <div className="col-xs-12 col-md-8 mb-sm">
                  <h4 className="unstyled">Get the Most Out of Hailtrace</h4>
                  <p className="">To get started, pick a custom field from the left sidebar to create.</p>
                  <p>These fields custom fields will be visible when you are editing your {this.props.type}s in addition to the fields that always exist on the {this.props.type}.</p>
                </div>
                <div className="well well-sm light col-xs-12 col-md-4">
                  <h3 className="unstyled mt-none">Get Started</h3>
                  <p>Select a field type to get started.</p>
                  <FieldPicker onSelect={this.handleFieldSelect.bind(this)} />
                </div>
              </div>
            </div>
          ) : (
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Form Preview</h3>
              </div>
              <div className="panel-body">
                <p className="alert alert-default panel-description">Below you will see a preview of your custom client fields.</p>
                <FieldList
                  fields={this.props.fields.map(field => {
                    if(this.state.tmp_field && this.state.tmp_field._id == field._id) {
                      return this.state.tmp_field;
                    }
                    else {
                      return field;
                    }
                  })}
                  groupOrder={this.props.groupOrder}
                  selected={this.state.selected}
                  disabled={true}
                  editMode={true}
                  editAdminFields={this.props.editAdminFields}
                  onSelectField={this.setSelectedField}
                  onUpdateField={this.props.onUpdateField}
                  onDeleteField={this.props.onDeleteField}
                  onChangeField={this.props.onChangeField}
                  onUpdateGroupOrder={this.props.onUpdateGroupOrder}
                />
              </div>
              <div className="panel-footer">
                <i className="fa fa-hand-pointer-o"></i> Click a field to edit it.
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal show={this.state.next_field_prototype ? true : false} onHide={this.handleClearPrototype}>
        <Modal.Body>
          <FieldSetup
            type={this.props.type}
            field={this.state.next_field_prototype}
            onSave={field => {
              this.handleClearPrototype()
              this.props.onCreateField(field);
            }}
            onChange={field => {
              this.setState({next_field_prototype : field});
            }}
            onCancel={e => this.setState({next_field_prototype : null})}
          />
        </Modal.Body>
      </Modal>
      <Modal show={this.state.confirm_field_change ? true : false} onHide={e => this.setState({confirm_field_change: false, next_id: null})}>
        <Modal.Header>
          <h3>Are you sure?</h3>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to change fields, you will lose all your changes to your current field.</p>
        </Modal.Body>
        <Modal.Footer>
          <div onClick={e => this.setState({confirm_field_change: false, next_id: null})} className="btn btn-default">No</div>
          <div onClick={e => this.setState({dirty: false, confirm_field_change: false}, e => this.setSelectedField(this.state.next_id))} className="btn btn-danger">Yes, discard my changes.</div>
          <div onClick={e => this.setState({dirty: false, confirm_field_change: false}, e => this.props.onUpdateField(this.state.tmp_field))} className="btn btn-success">No, save it first.</div>
        </Modal.Footer>
      </Modal>
    </div>
  }
}

FormBuilder.propTypes = {
  groupOrder: PropTypes.arrayOf(PropTypes.string),
  fields : PropTypes.arrayOf(PropTypes.shape({
    entity : PropTypes.string,
    _id : PropTypes.string,
    flex : PropTypes.number,
    owners : PropTypes.array,
    account : PropTypes.string,
    label : PropTypes.string,
    name : PropTypes.string,
    order : PropTypes.number,
    type : PropTypes.string,
    ref : PropTypes.string,
    is_required : PropTypes.bool,
  })),
  onCreateField : PropTypes.func.isRequired,
  onUpdateField : PropTypes.func.isRequired,
  onDeleteField : PropTypes.func.isRequired,
}

export default FormBuilder;



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/form-builder.js